import React from 'react';
import { connect } from 'react-redux';
import { saveProfile } from './actions';

class ProfileSaver extends React.Component {

	componentWillReceiveProps({ user }) {
		if (user.saveProfile && !this.props.user.saveProfile) {
			this.props.saveProfile(user.profile);
		}
	}

	render() {
		return null;
	}
}

function bindAction(dispatch) {
	return {
		saveProfile: (profile) => dispatch(saveProfile(profile))
	};
}

const mapStateToProps = (state) => ({
	user: state.user
});

export default connect(mapStateToProps, bindAction)(ProfileSaver);

